module.exports = __webpack_public_path__ + "site/img/Maps_7LaiChiKok.2ee1d8d6.jpg";